// TODO: alphabetize move names. I'm trying to implement this on a low-quality laptop under time pressure, so I haven't bothered doing so.
export const FormatsData: {[k: string]: ModdedSpeciesFormatsData} = {
	bulbasaur: {
		tier: "LC",
	},
	ivysaur: {
		tier: "NFE",
	},
	venusaur: {
		tier: "RU",
		doublesTier: "DUU",
		randomBattleMoves: ["gigadrain", "leechseed", "sleeppowder", "sludgebomb", "substitute"],
	},
	charmander: {
		tier: "LC",
	},
	charmeleon: {
		tier: "NFE",
	},
	charizard: {
		tier: "PUBL",
		doublesTier: "DUU",
		randomBattleMoves: ["airslash", "earthquake", "fireblast", "focusblast", "roost"],
	},
	squirtle: {
		tier: "LC",
	},
	wartortle: {
		tier: "NFE",
	},
	blastoise: {
		tier: "UU",
		doublesTier: "DUU",
		randomBattleMoves: ["earthquake", "icebeam", "protect", "rapidspin", "roar", "scald", "shellsmash"],
	},
	caterpie: {
		tier: "LC",
	},
	metapod: {
		tier: "NFE",
	},
	butterfree: {
		tier: "PU",
		doublesTier: "DUU",
		randomBattleMoves: ["airslash", "bugbuzz", "gigadrain", "quiverdance", "sleeppowder"],
	},
	weedle: {
		tier: "LC",
	},
	kakuna: {
		tier: "NFE",
	},
	beedrill: {
		tier: "PU",
		doublesTier: "DUU",
		randomBattleMoves: ["poisonjab", "protect", "toxicspikes", "uturn"],
	},
	beedrillmega: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	pidgey: {
		tier: "LC",
	},
	pidgeotto: {
		tier: "NFE",
	},
	pidgeot: {
		tier: "PU",
		doublesTier: "DUU",
		randomBattleMoves: ["bravebird", "defog", "quickattack", "roost", "steelwing", "uturn"],
	},
	pidgeotmega: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	rattata: {
		tier: "LC",
	},
	raticate: {
		tier: "PU",
		doublesTier: "DUU",
		randomBattleMoves: ["crunch", "facade", "flamewheel", "protect", "suckerpunch", "swordsdance"],
	},
	spearow: {
		tier: "LC",
	},
	fearow: {
		tier: "PU",
		doublesTier: "DUU",
		randomBattleMoves: ["drillpeck", "drillrun", "gigaimpact", "uturn"],
	},
	ekans: {
		tier: "LC",
	},
	arbok: {
		tier: "PU",
		doublesTier: "DUU",
		randomBattleMoves: ["earthquake", "glare", "gunkshot", "suckerpunch"],
	},
	pichu: {
		tier: "LC",
	},
	pikachu: {
		tier: "NFE",
		randomBattleMoves: ["grassknot", "surf", "voltswitch", "volttackle"],
	},
	raichu: {
		tier: "PUBL",
		doublesTier: "DOU",
		randomBattleMoves: ["focusblast", "grassknot", "nastyplot", "surf", "thunderbolt"],
	},
	sandshrew: {
		tier: "LC",
	},
	sandslash: {
		tier: "NU",
		doublesTier: "DUU",
		randomBattleMoves: ["earthquake", "rapidspin", "stealthrock", "stoneedge", "swordsdance", "xscissor"],
	},
	nidoranf: {
		tier: "LC",
	},
	nidorina: {
		tier: "NFE",
	},
	nidoqueen: {
		tier: "RU",
		doublesTier: "DUU",
		randomBattleMoves: ["earthpower", "flamethrower", "icebeam", "sludgewave", "stealthrock", "toxicspikes"],
	},
	nidoranm: {
		tier: "LC",
	},
	nidorino: {
		tier: "NFE",
	},
	nidoking: {
		tier: "OU",
		doublesTier: "DUU",
		randomBattleMoves: ["earthpower", "flamethrower", "icebeam", "sludgewave", "substitute"],
	},
	cleffa: {
		tier: "LC",
	},
	clefairy: {
		tier: "NFE",
	},
	clefable: {
		tier: "OU",
		doublesTier: "DUU",
		randomBattleMoves: ["calmmind", "fireblast", "moonblast", "moonlight", "stealthrock", "thunderwave"],
	},
	vulpix: {
		tier: "NFE",
	},
	ninetales: {
		tier: "PU",
		doublesTier: "DUU",
		randomBattleMoves: ["fireblast", "hypnosis", "nastyplot", "solarbeam", "willowisp"],
	},
	igglybuff: {
		tier: "LC",
	},
	jigglypuff: {
		tier: "NFE",
	},
	wigglytuff: {
		tier: "PU",
		doublesTier: "DUU",
		randomBattleMoves: ["dazzlinggleam", "fireblast", "lightscreen", "reflect", "stealthrock", "thunderwave"],
	},
	zubat: {
		tier: "LC",
	},
	golbat: {
		tier: "NFE",
	},
	crobat: {
		tier: "UU",
		doublesTier: "DUU",
		randomBattleMoves: ["bravebird", "defog", "roost", "toxic", "uturn"],
	},
	oddish: {
		tier: "LC",
	},
	gloom: {
		tier: "NFE",
	},
	vileplume: {
		tier: "RU",
		doublesTier: "DUU",
		randomBattleMoves: ["aromatherapy", "gigadrain", "sleeppowder", "sludgebomb", "strengthsap"],
	},
	bellossom: {
		tier: "PU",
		doublesTier: "DOU",
		randomBattleMoves: ["gigadrain", "moonblast", "quiverdance", "sleeppowder", "strengthsap"],
	},
	paras: {
		tier: "LC",
	},
	parasect: {
		tier: "PU",
		doublesTier: "DUU",
		randomBattleMoves: ["leechseed", "spore", "substitute", "xscissor"],
	},
	venonat: {
		tier: "LC",
	},
	venomoth: {
		tier: "RUBL",
		doublesTier: "DUU",
		randomBattleMoves: ["bugbuzz", "quiverdance", "sleeppowder", "sludgebomb", "substitute"],
	},
	diglett: {
		tier: "LC",
	},
	dugtrio: {
		tier: "PU",
		doublesTier: "DUU",
		randomBattleMoves: ["aerialace", "earthquake", "stoneedge", "suckerpunch"],
	},
	meowth: {
		tier: "LC",
	},
	persian: {
		tier: "PU",
		doublesTier: "DUU",
		randomBattleMoves: ["aerialace", "bite", "fakeout", "covet", "uturn"],
	},
	psyduck: {
		tier: "LC",
	},
	golduck: {
		tier: "PU",
		doublesTier: "DUU",
		randomBattleMoves: ["calmmind", "encore", "focusblast", "hydropump", "hypnosis", "icebeam"],
	},
	mankey: {
		tier: "LC",
	},
	primeape: {
		tier: "RU",
		doublesTier: "DUU",
		randomBattleMoves: ["closecombat", "earthquake", "poisonjab", "stoneedge", "uturn"],
	},
	growlithe: {
		tier: "LC",
	},
	arcanine: {
		tier: "UU",
		doublesTier: "DOU",
		randomBattleMoves: ["closecombat", "extremespeed", "flareblitz", "morningsun", "willowisp"],
	},
	poliwag: {
		tier: "LC",
	},
	poliwhirl: {
		tier: "NFE",
	},
	poliwrath: {
		tier: "PU",
		doublesTier: "DUU",
		randomBattleMoves: ["bulkup", "drainpunch", "poisonjab", "raindance", "waterfall"],
	},
	politoed: {
		tier: "PU",
		doublesTier: "DOU",
		randomBattleMoves: ["encore", "hypnosis", "icebeam", "rest", "scald"],
	},
	abra: {
		tier: "LC",
	},
	kadabra: {
		tier: "NFE",
	},
	alakazam: {
		tier: "OU",
		doublesTier: "DUU",
		randomBattleMoves: ["dazzlinggleam", "focusblast", "nastyplot", "psychic", "shadowball"],
	},
	machop: {
		tier: "LC",
	},
	machoke: {
		tier: "NFE",
	},
	machamp: {
		tier: "RU",
		doublesTier: "DUU",
		randomBattleMoves: ["bulletpunch", "closecombat", "dynamicpunch", "facade", "knockoff", "stoneedge"],
	},
	bellsprout: {
		tier: "LC",
	},
	weepinbell: {
		tier: "NFE",
	},
	victreebel: {
		tier: "PU",
		doublesTier: "DUU",
		randomBattleMoves: ["knockoff", "poisonjab", "powerwhip", "sleeppowder", "strengthsap", "swordsdance"],
	},
	tentacool: {
		tier: "LC",
	},
	tentacruel: {
		tier: "UU",
		doublesTier: "DUU",
		randomBattleMoves: ["haze", "knockoff", "rapidspin", "scald", "sludgebomb"],
	},
	geodude: {
		tier: "LC",
	},
	graveler: {
		tier: "NFE",
	},
	golem: {
		tier: "PU",
		doublesTier: "DUU",
		randomBattleMoves: ["earthquake", "explosion", "heavyslam", "stealthrock", "stoneedge"],
	},
	ponyta: {
		tier: "LC",
	},
	rapidash: {
		tier: "PU",
		doublesTier: "DUU",
		randomBattleMoves: ["flareblitz", "highhorsepower", "hypnosis", "morningsun", "swordsdance", "willowisp"],
	},
	slowpoke: {
		tier: "LC",
	},
	slowbro: {
		tier: "RU",
		doublesTier: "DUU",
		randomBattleMoves: ["calmmind", "icebeam", "psychic", "scald", "slackoff", "thunderwave"],
	},
	slowking: {
		tier: "RU",
		doublesTier: "DUU",
		randomBattleMoves: ["calmmind", "icebeam", "psychic", "scald", "slackoff"],
	},
	magnemite: {
		tier: "LC",
	},
	magneton: {
		tier: "PU",
		doublesTier: "NFE",
	},
	magnezone: {
		tier: "OU",
		doublesTier: "DUU",
		randomBattleMoves: ["flashcannon", "mirrorcoat", "thunderbolt", "voltswitch"],
	},
	farfetchd: {
		tier: "PU",
		doublesTier: "DUU",
		randomBattleMoves: ["bravebird", "knockoff", "leafblade", "quickattack", "slash"],
	},
	doduo: {
		tier: "LC",
	},
	dodrio: {
		tier: "PU",
		doublesTier: "DUU",
		randomBattleMoves: ["bravebird", "facade", "quickattack", "roost", "steelwing", "swordsdance"],
	},
	seel: {
		tier: "LC",
	},
	dewgong: {
		tier: "PU",
		doublesTier: "DUU",
		randomBattleMoves: ["icebeam", "perishsong", "protect", "rest", "sleeptalk", "surf"],
	},
	grimer: {
		tier: "LC",
	},
	muk: {
		tier: "PU",
		doublesTier: "DUU",
		randomBattleMoves: ["brickbreak", "curse", "explosion", "gunkshot", "shadowsneak"],
	},
	shellder: {
		tier: "LC",
	},
	cloyster: {
		tier: "UU",
		doublesTier: "DUU",
		randomBattleMoves: ["hydropump", "iciclespear", "rockblast", "shellsmash"],
	},
	gastly: {
		tier: "LC",
	},
	haunter: {
		tier: "NUBL",
		doublesTier: "NFE",
	},
	gengar: {
		tier: "Uber",
		doublesTier: "DUU",
		randomBattleMoves: ["focusblast", "nastyplot", "shadowball", "sludgebomb", "thunderbolt"],
	},
	onix: {
		tier: "LC",
	},
	steelix: {
		tier: "RU",
		doublesTier: "DUU",
		randomBattleMoves: ["curse", "earthquake", "gyroball", "stealthrock", "stoneedge"],
	},
	drowzee: {
		tier: "LC",
	},
	hypno: {
		tier: "PU",
		doublesTier: "DUU",
		randomBattleMoves: ["focusblast", "psychic", "shadowball", "thunderwave"],
	},
	krabby: {
		tier: "LC",
	},
	kingler: {
		tier: "PUBL",
		doublesTier: "DUU",
		randomBattleMoves: ["agility", "razorshell", "rockslide", "swordsdance", "xscissor"],
	},
	voltorb: {
		tier: "LC",
	},
	electrode: {
		tier: "PU",
		doublesTier: "DUU",
		randomBattleMoves: ["explosion", "lightscreen", "taunt", "thunderbolt", "voltswitch"],
	},
	exeggcute: {
		tier: "LC",
	},
	exeggutor: {
		tier: "NUBL",
		doublesTier: "DUU",
		randomBattleMoves: ["gigadrain", "leechseed", "psychic", "sleeppowder", "substitute"],
	},
	cubone: {
		tier: "LC",
	},
	marowak: {
		tier: "PU",
		doublesTier: "DUU",
		randomBattleMoves: ["doubleedge", "earthquake", "stealthrock", "stoneedge"],
	},
	tyrogue: {
		tier: "LC",
	},
	hitmonlee: {
		tier: "NU",
		doublesTier: "DUU",
		randomBattleMoves: ["bulkup", "bulletpunch", "earthquake", "highjumpkick", "stoneedge"],
	},
	hitmonchan: {
		tier: "RU",
		doublesTier: "DUU",
		randomBattleMoves: ["bulkup", "drainpunch", "icepunch", "machpunch", "rapidspin", "stoneedge"],
	},
	hitmontop: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["closecombat", "machpunch", "rapidspin", "stoneedge", "suckerpunch"],
	},
	lickitung: {
		tier: "LC",
	},
	lickilicky: {
		tier: "PU",
		doublesTier: "DUU",
		randomBattleMoves: ["bodyslam", "hammerarm", "knockoff", "powerwhip", "swordsdance"],
	},
	koffing: {
		tier: "LC",
	},
	weezing: {
		tier: "PU",
		doublesTier: "DUU",
		randomBattleMoves: ["fireblast", "painsplit", "sludgebomb", "toxicspikes", "willowisp"],
	},
	rhyhorn: {
		tier: "LC",
	},
	rhydon: {
		tier: "NU",
		doublesTier: "NFE",
	},
	rhyperior: {
		tier: "RU",
		doublesTier: "DUU",
		randomBattleMoves: ["earthquake", "firefang", "megahorn", "stoneedge", "swordsdance"],
	},
	happiny: {
		tier: "LC",
	},
	chansey: {
		tier: "RU",
	},
	blissey: {
		tier: "OU",
		doublesTier: "DUU",
		randomBattleMoves: ["seismictoss", "softboiled", "stealthrock", "thunderwave"],
	},
	tangela: {
		tier: "NFE",
	},
	tangrowth: {
		tier: "OU",
		doublesTier: "DUU",
		randomBattleMoves: ["earthquake", "knockoff", "leechseed", "powerwhip", "sleeppowder", "sludgebomb"],
	},
	kangaskhan: {
		tier: "PUBL",
		doublesTier: "DUU",
		randomBattleMoves: ["crunch", "doubleedge", "earthquake", "fakeout", "hammerarm"],
	},
	horsea: {
		tier: "LC",
	},
	seadra: {
		tier: "NFE",
	},
	kingdra: {
		tier: "RUBL",
		doublesTier: "DOU",
		randomBattleMoves: ["dracometeor", "hydropump", "icebeam", "raindance"],
	},
	goldeen: {
		tier: "LC",
	},
	seaking: {
		tier: "PU",
		doublesTier: "DUU",
		randomBattleMoves: ["megahorn", "raindance", "swordsdance", "waterfall"],
	},
	staryu: {
		tier: "LC",
	},
	starmie: {
		tier: "OU",
		doublesTier: "DUU",
		randomBattleMoves: ["hydropump", "icebeam", "psychic", "rapidspin", "recover", "scald", "thunderbolt"],
	},
	mimejr: {
		tier: "LC",
	},
	mrmime: {
		tier: "NU",
		doublesTier: "DUU",
		randomBattleMoves: ["dazzlinggleam", "focusblast", "nastyplot", "psychic", "thunderbolt"],
	},
	scyther: {
		tier: "NU",
		doublesTier: "NFE",
		randomBattleMoves: ["aerialace", "brickbreak", "quickattack", "roost", "swordsdance", "thief", "uturn"],
	},
	scizor: {
		tier: "OU",
		doublesTier: "DOU",
		randomBattleMoves: ["brickbreak", "bulletpunch", "roost", "swordsdance", "uturn", "defog"],
	},
	smoochum: {
		tier: "LC",
	},
	jynx: {
		tier: "NU",
		doublesTier: "DUU",
		randomBattleMoves: ["icebeam", "lovelykiss", "nastyplot", "psychic", "substitute"],
	},
	elekid: {
		tier: "LC",
	},
	electabuzz: {
		tier: "NFE",
	},
	electivire: {
		tier: "NU",
		doublesTier: "DUU",
		randomBattleMoves: ["crosschop", "earthquake", "flamethrower", "icepunch", "voltswitch", "wildcharge"],
	},
	magby: {
		tier: "LC",
	},
	magmar: {
		tier: "NFE",
	},
	magmortar: {
		tier: "RU",
		doublesTier: "DUU",
		randomBattleMoves: ["earthquake", "fireblast", "psychic", "taunt", "thunderbolt"],
	},
	pinsir: {
		tier: "PUBL",
		doublesTier: "DUU",
		randomBattleMoves: ["closecombat", "earthquake", "stealthrock", "stoneedge", "xscissor"],
	},
	tauros: {
		tier: "NUBL",
		doublesTier: "DUU",
		randomBattleMoves: ["earthquake", "rockclimb", "rockslide", "zenheadbutt"],
	},
	magikarp: {
		tier: "LC",
	},
	gyarados: {
		tier: "RUBL",
		doublesTier: "DOU",
		randomBattleMoves: ["dragondance", "earthquake", "icefang", "stoneedge", "waterfall"],
	},
	lapras: {
		tier: "PU",
		doublesTier: "DUU",
		randomBattleMoves: ["blizzard", "freezedry", "surf", "thunderbolt"],
	},
	ditto: {
		tier: "NU",
		doublesTier: "DUU",
		randomBattleMoves: ["transform"],
	},
	eevee: {
		tier: "LC",
	},
	vaporeon: {
		tier: "RU",
		doublesTier: "DUU",
		randomBattleMoves: ["haze", "icebeam", "protect", "scald", "wish"],
	},
	jolteon: {
		tier: "RU",
		doublesTier: "DUU",
		randomBattleMoves: ["batonpass", "shadowball", "thunderbolt", "voltswitch", "yawn"],
	},
	flareon: {
		tier: "PU",
		doublesTier: "DUU",
		randomBattleMoves: ["facade", "flareblitz", "quickattack", "willowisp"],
	},
	espeon: {
		tier: "UU",
		doublesTier: "DUU",
		randomBattleMoves: ["calmmind", "dazzlinggleam", "morningsun", "psychic", "shadowball"],
	},
	umbreon: {
		tier: "UU",
		doublesTier: "DUU",
		randomBattleMoves: ["foulplay", "protect", "taunt", "wish"],
	},
	leafeon: {
		tier: "PU",
		doublesTier: "DUU",
		randomBattleMoves: ["doubleedge", "leafblade", "swordsdance", "synthesis", "xscissor"],
	},
	glaceon: {
		tier: "PU",
		doublesTier: "DUU",
		randomBattleMoves: ["freezedry", "icebeam", "roar", "shadowball", "waterpulse"],
	},
	porygon: {
		tier: "LC",
	},
	porygon2: {
		tier: "NFE",
	},
	porygonz: {
		tier: "UU",
		doublesTier: "DUU",
		randomBattleMoves: ["darkpulse", "icebeam", "nastyplot", "thunderbolt", "triattack"],
	},
	omanyte: {
		tier: "LC",
	},
	omastar: {
		tier: "RU",
		doublesTier: "DUU",
		randomBattleMoves: ["ancientpower", "hydropump", "icebeam", "shellsmash"],
	},
	kabuto: {
		tier: "LC",
	},
	kabutops: {
		tier: "RU",
		doublesTier: "DUU",
		randomBattleMoves: ["knockoff", "liquidation", "rapidspin", "stoneedge", "swordsdance"],
	},
	aerodactyl: {
		tier: "NUBL",
		doublesTier: "DUU",
		randomBattleMoves: ["earthquake", "roost", "stealthrock", "stoneedge", "defog"],
	},
	munchlax: {
		tier: "NFE",
	},
	snorlax: {
		tier: "UU",
		doublesTier: "DUU",
		randomBattleMoves: ["bodyslam", "curse", "rest", "sleeptalk"],
	},
	articuno: {
		tier: "PU",
		doublesTier: "DUU",
		randomBattleMoves: ["defog", "icebeam", "roost", "uturn"],
	},
	zapdos: {
		tier: "UU",
		doublesTier: "DOU",
		randomBattleMoves: ["defog", "discharge", "roost", "substitute", "uturn"],
	},
	moltres: {
		tier: "RU",
		doublesTier: "DUU",
		randomBattleMoves: ["fireblast", "hurricane", "roost", "uturn", "willowisp"],
	},
	dratini: {
		tier: "LC",
	},
	dragonair: {
		tier: "NFE",
	},
	dragonite: {
		tier: "OU",
		doublesTier: "DUU",
		randomBattleMoves: ["dragondance", "earthquake", "extremespeed", "outrage", "roost"],
	},
	mewtwo: {
		tier: "Uber",
		doublesTier: "DUber",
		randomBattleMoves: ["aurasphere", "fireblast", "nastyplot", "psystrike", "recover", "shadowball"],
	},
	mew: {
		tier: "UU",
		doublesTier: "DUU",
		randomBattleMoves: ["aurasphere", "calmmind", "psychic", "roost", "shadowball", "defog"],
	},
	chikorita: {
		tier: "LC",
	},
	bayleef: {
		tier: "NFE",
	},
	meganium: {
		tier: "PU",
		doublesTier: "DUU",
		randomBattleMoves: ["aromatherapy", "gigadrain", "leechseed", "lightscreen", "reflect"],
	},
	cyndaquil: {
		tier: "LC",
	},
	quilava: {
		tier: "NFE",
	},
	typhlosion: {
		tier: "NU",
		doublesTier: "DUU",
		randomBattleMoves: ["eruption", "extrasensory", "fireblast", "focusblast"],
	},
	totodile: {
		tier: "LC",
	},
	croconaw: {
		tier: "NFE",
	},
	feraligatr: {
		tier: "OU",
		doublesTier: "DUU",
		randomBattleMoves: ["aquajet", "crunch", "dragondance", "icepunch", "waterfall"],
	},
	sentret: {
		tier: "LC",
	},
	furret: {
		tier: "PU",
		doublesTier: "DUU",
		randomBattleMoves: ["doubleedge", "shadowclaw", "suckerpunch", "uturn"],
	},
	hoothoot: {
		tier: "LC",
	},
	noctowl: {
		tier: "PU",
		doublesTier: "DUU",
		randomBattleMoves: ["hurricane", "hypnosis", "nastyplot", "roost", "shadowball", "defog"],
	},
	ledyba: {
		tier: "LC",
	},
	ledian: {
		tier: "PU",
		doublesTier: "DUU",
		randomBattleMoves: ["knockoff", "lightscreen", "reflect", "roost", "uturn"],
	},
	spinarak: {
		tier: "LC",
	},
	ariados: {
		tier: "PU",
		doublesTier: "DUU",
		randomBattleMoves: ["lunge", "poisonjab", "stickyweb", "toxicspikes"],
	},
	chinchou: {
		tier: "LC",
	},
	lanturn: {
		tier: "NU",
		doublesTier: "DUU",
		randomBattleMoves: ["discharge", "icebeam", "scald", "thunderwave", "voltswitch"],
	},
	togepi: {
		tier: "LC",
	},
	togetic: {
		tier: "NFE",
	},
	togekiss: {
		tier: "OU",
		doublesTier: "DOU",
		randomBattleMoves: ["airslash", "aurasphere", "fireblast", "roost", "thunderwave", "defog"],
	},
	natu: {
		tier: "LC",
	},
	xatu: {
		tier: "RU",
		doublesTier: "DUU",
		randomBattleMoves: ["airslash", "psychic", "roost", "teleport", "thunderwave"],
	},
	mareep: {
		tier: "LC",
	},
	flaaffy: {
		tier: "NFE",
	},
	ampharos: {
		tier: "PU",
		doublesTier: "DUU",
		randomBattleMoves: ["focusblast", "powergem", "thunderbolt", "voltswitch"],
	},
	azurill: {
		tier: "LC",
	},
	marill: {
		tier: "NFE",
	},
	azumarill: {
		tier: "OU",
		doublesTier: "DOU",
		randomBattleMoves: ["aquajet", "bellydrum", "playrough", "superpower", "waterfall"],
	},
	bonsly: {
		tier: "LC",
	},
	sudowoodo: {
		tier: "PU",
		doublesTier: "DUU",
		randomBattleMoves: ["earthquake", "headsmash", "explosion", "stealthrock", "suckerpunch"],
	},
	hoppip: {
		tier: "LC",
	},
	skiploom: {
		tier: "NFE",
	},
	jumpluff: {
		tier: "PU",
		doublesTier: "DUU",
		randomBattleMoves: ["acrobatics", "leechseed", "sleeppowder", "strengthsap", "substitute"],
	},
	aipom: {
		tier: "LC",
	},
	ambipom: {
		tier: "UU",
		doublesTier: "DUU",
		randomBattleMoves: ["aerialace", "brickbreak", "doublehit", "fakeout", "switcheroo", "thief", "uturn"],
	},
	sunkern: {
		tier: "LC",
	},
	sunflora: {
		tier: "PU",
		doublesTier: "DUU",
		randomBattleMoves: ["energyball", "lightscreen", "sludgebomb", "synthesis"],
	},
	yanma: {
		tier: "NFE",
	},
	yanmega: {
		tier: "UU",
		doublesTier: "DUU",
		randomBattleMoves: ["airslash", "bugbuzz", "gigadrain", "protect", "uturn"],
	},
	wooper: {
		tier: "LC",
	},
	quagsire: {
		tier: "RU",
		doublesTier: "DUU",
		randomBattleMoves: ["earthquake", "recover", "scald", "toxic"],
	},
	murkrow: {
		tier: "NFE",
	},
	honchkrow: {
		tier: "RU",
		doublesTier: "DUU",
		randomBattleMoves: ["bravebird", "roost", "suckerpunch", "taunt"],
	},
	misdreavus: {
		tier: "NFE",
	},
	mismagius: {
		tier: "UU",
		doublesTier: "DUU",
		randomBattleMoves: ["dazzlinggleam", "destinybond", "nastyplot", "painsplit", "shadowball", "substitute", "thunderbolt", "willowisp"],
	},
	unown: {
		tier: "PU",
		doublesTier: "DUU",
		randomBattleMoves: ["hiddenpowerfighting", "hiddenpowerpsychic"],
	},
	wynaut: {
		tier: "LC",
	},
	wobbuffet: {
		tier: "PU",
		doublesTier: "DUU",
		randomBattleMoves: ["counter", "destinybond", "encore", "mirrorcoat"],
	},
	girafarig: {
		tier: "PU",
		doublesTier: "DUU",
		randomBattleMoves: ["dazzlinggleam", "nastyplot", "psychic", "shadowball", "thunderbolt"],
	},
	pineco: {
		tier: "LC",
	},
	forretress: {
		tier: "UU",
		doublesTier: "DUU",
		randomBattleMoves: ["gyroball", "rapidspin", "spikes", "toxicspikes", "voltswitch"],
	},
	dunsparce: {
		tier: "PU",
		doublesTier: "DUU",
		randomBattleMoves: ["bite", "bodyslam", "coil", "roost"],
	},
	gligar: {
		tier: "NU",
		doublesTier: "NFE",
	},
	gliscor: {
		tier: "OU",
		doublesTier: "DUU",
		randomBattleMoves: ["earthquake", "icefang", "knockoff", "roost", "stealthrock", "swordsdance", "taunt", "uturn", "defog"],
	},
	snubbull: {
		tier: "LC",
	},
	granbull: {
		tier: "RU",
		doublesTier: "DUU",
		randomBattleMoves: ["crunch", "earthquake", "healbell", "playrough", "thunderwave"],
	},
	qwilfish: {
		tier: "NU",
		doublesTier: "DUU",
		randomBattleMoves: ["destinybond", "poisonjab", "spikes", "thunderwave", "toxicspikes", "waterfall"],
	},
	shuckle: {
		tier: "PU",
		doublesTier: "DUU",
		randomBattleMoves: ["knockoff", "stealthrock", "stickyweb", "toxic"],
	},
	heracross: {
		tier: "UUBL",
		doublesTier: "DUU",
		randomBattleMoves: ["closecombat", "facade", "megahorn", "stoneedge", "throatchop"],
	},
	sneasel: {
		tier: "PUBL",
		doublesTier: "NFE",
	},
	weavile: {
		tier: "OU",
		doublesTier: "DUU",
		randomBattleMoves: ["brickbreak", "iceshard", "iciclecrash", "swordsdance", "throatchop"],
	},
	teddiursa: {
		tier: "LC",
	},
	ursaring: {
		tier: "NU",
		doublesTier: "DUU",
		randomBattleMoves: ["closecombat", "crunch", "facade", "protect", "swordsdance"],
	},
	slugma: {
		tier: "LC",
	},
	magcargo: {
		tier: "PU",
		doublesTier: "DUU",
		randomBattleMoves: ["ancientpower", "earthpower", "fireblast", "lavaplume", "recover", "shellsmash", "stealthrock"],
	},
	swinub: {
		tier: "LC",
	},
	piloswine: {
		tier: "NFE",
	},
	mamoswine: {
		tier: "OU",
		doublesTier: "DOU",
		randomBattleMoves: ["earthquake", "iceshard", "iciclecrash", "stealthrock", "stoneedge"],
	},
	corsola: {
		tier: "PU",
		doublesTier: "DUU",
		randomBattleMoves: ["icebeam", "powergem", "recover", "scald", "stealthrock"],
	},
	remoraid: {
		tier: "LC",
	},
	octillery: {
		tier: "PU",
		doublesTier: "DUU",
		randomBattleMoves: ["energyball", "fireblast", "gunkshot", "hydropump", "icebeam", "protect"],
	},
	delibird: {
		tier: "PU",
		doublesTier: "DUU",
		randomBattleMoves: ["destinybond", "freezedry", "rapidspin", "spikes"],
	},
	mantyke: {
		tier: "LC",
	},
	mantine: {
		tier: "RU",
		doublesTier: "DUU",
		randomBattleMoves: ["defog", "icebeam", "roost", "scald"],
	},
	skarmory: {
		tier: "OU",
		doublesTier: "DUU",
		randomBattleMoves: ["bravebird", "roost", "spikes", "stealthrock", "whirlwind", "defog"],
	},
	houndour: {
		tier: "LC",
	},
	houndoom: {
		tier: "RU",
		doublesTier: "DUU",
		randomBattleMoves: ["darkpulse", "fireblast", "nastyplot", "suckerpunch"],
	},
	phanpy: {
		tier: "LC",
	},
	donphan: {
		tier: "OU",
		doublesTier: "DUU",
		randomBattleMoves: ["earthquake", "iceshard", "knockoff", "rapidspin", "stealthrock", "stoneedge"],
	},
	stantler: {
		tier: "PU",
		doublesTier: "DUU",
		randomBattleMoves: ["doubleedge", "earthquake", "megahorn", "zenheadbutt"],
	},
	smeargle: {
		tier: "PUBL",
		doublesTier: "DUber",
		randomBattleMoves: ["spikes", "spore", "stealthrock", "stickyweb", "toxicspikes", "whirlwind"],
	},
	miltank: {
		tier: "NU",
		doublesTier: "DUU",
		randomBattleMoves: ["bodyslam", "curse", "earthquake", "milkdrink", "stealthrock"],
	},
	raikou: {
		tier: "UUBL",
		doublesTier: "DOU",
		randomBattleMoves: ["calmmind", "scald", "substitute", "thunderbolt", "voltswitch"],
	},
	entei: {
		tier: "UU",
		doublesTier: "DOU",
		randomBattleMoves: ["bulldoze", "extremespeed", "sacredfire", "stoneedge"],
	},
	suicune: {
		tier: "UU",
		doublesTier: "DOU",
		randomBattleMoves: ["calmmind", "rest", "scald", "sleeptalk"],
	},
	larvitar: {
		tier: "LC",
	},
	pupitar: {
		tier: "NFE",
	},
	tyranitar: {
		tier: "OU",
		doublesTier: "DOU",
		randomBattleMoves: ["crunch", "dragondance", "earthquake", "stealthrock", "stoneedge"],
	},
	lugia: {
		tier: "Uber",
		doublesTier: "DUber",
		randomBattleMoves: ["aeroblast", "psychic", "roost", "substitute", "whirlwind"],
	},
	hooh: {
		tier: "Uber",
		doublesTier: "DUber",
		randomBattleMoves: ["earthquake", "roost", "sacredfire", "substitute", "thunderwave"],
	},
	celebi: {
		tier: "UU",
		doublesTier: "DOU",
		randomBattleMoves: ["dazzlinggleam", "gigadrain", "leafstorm", "nastyplot", "psychic", "recover", "uturn"],
	},
	treecko: {
		tier: "LC",
	},
	grovyle: {
		tier: "NFE",
	},
	sceptile: {
		tier: "NUBL",
		doublesTier: "DUU",
		randomBattleMoves: ["earthquake", "focusblast", "gigadrain", "leafstorm", "leechseed", "rockslide", "substitute"],
	},
	torchic: {
		tier: "LC",
	},
	combusken: {
		tier: "NFE",
	},
	blaziken: {
		tier: "Uber",
		doublesTier: "DUU",
		randomBattleMoves: ["closecombat", "earthquake", "flareblitz", "stoneedge", "swordsdance"],
	},
	mudkip: {
		tier: "LC",
	},
	marshtomp: {
		tier: "NFE",
	},
	swampert: {
		tier: "UU",
		doublesTier: "DUU",
		randomBattleMoves: ["earthquake", "icebeam", "scald", "stealthrock", "stoneedge"],
	},
	poochyena: {
		tier: "LC",
	},
	mightyena: {
		tier: "PU",
		doublesTier: "DUU",
		randomBattleMoves: ["crunch", "firefang", "irontail", "playrough", "suckerpunch"],
	},
	zigzagoon: {
		tier: "LC",
	},
	linoone: {
		tier: "NUBL",
		doublesTier: "DUU",
		randomBattleMoves: ["bellydrum", "extremespeed", "irontail", "shadowclaw"],
	},
	wurmple: {
		tier: "LC",
	},
	silcoon: {
		tier: "NFE",
	},
	beautifly: {
		tier: "PU",
		doublesTier: "DUU",
		randomBattleMoves: ["aircutter", "bugbuzz", "energyball", "quiverdance", "roost"],
	},
	cascoon: {
		tier: "NFE",
	},
	dustox: {
		tier: "PU",
		doublesTier: "DUU",
		randomBattleMoves: ["bugbuzz", "roost", "sludgebomb", "toxic", "uturn", "defog"],
	},
	lotad: {
		tier: "LC",
	},
	lombre: {
		tier: "NFE",
	},
	ludicolo: {
		tier: "PUBL",
		doublesTier: "DOU",
		randomBattleMoves: ["gigadrain", "hydropump", "icebeam", "raindance", "scald"],
	},
	seedot: {
		tier: "LC",
	},
	nuzleaf: {
		tier: "NFE",
	},
	shiftry: {
		tier: "NU",
		doublesTier: "DUU",
		randomBattleMoves: ["brickbreak", "fakeout", "leafblade", "nightslash", "suckerpunch", "swordsdance"],
	},
	taillow: {
		tier: "LC",
	},
	swellow: {
		tier: "RU",
		doublesTier: "DUU",
		randomBattleMoves: ["bravebird", "facade", "quickattack", "roost", "steelwing", "uturn"],
	},
	wingull: {
		tier: "LC",
	},
	pelipper: {
		tier: "PU",
		doublesTier: "DOU",
		randomBattleMoves: ["defog", "hurricane", "hydropump", "icebeam", "roost", "scald", "uturn"],
	},
	ralts: {
		tier: "LC",
	},
	kirlia: {
		tier: "NFE",
	},
	gardevoir: {
		tier: "UU",
		doublesTier: "DOU",
		randomBattleMoves: ["calmmind", "focusblast", "moonblast", "psychic", "shadowball", "substitute"],
	},
	gallade: {
		tier: "RU",
		doublesTier: "DUU",
		randomBattleMoves: ["closecombat", "earthquake", "knockoff", "psychocut", "swordsdance"],
	},
	surskit: {
		tier: "LC",
	},
	masquerain: {
		tier: "PU",
		doublesTier: "DUU",
		randomBattleMoves: ["airslash", "bugbuzz", "quiverdance", "scald", "stickyweb"],
	},
	shroomish: {
		tier: "LC",
	},
	breloom: {
		tier: "OU",
		doublesTier: "DOU",
		randomBattleMoves: ["bulletseed", "focuspunch", "machpunch", "rocktomb", "spore", "substitute", "swordsdance"],
	},
	slakoth: {
		tier: "LC",
	},
	vigoroth: {
		tier: "NFE",
		randomBattleMoves: ["bodyslam", "bulkup", "earthquake", "playrough", "shadowclaw", "slackoff"],
	},
	slaking: {
		tier: "PU",
		doublesTier: "DUU",
		randomBattleMoves: ["bodyslam", "earthquake", "gigaimpact", "hammerarm", "playrough", "suckerpunch"],
	},
	nincada: {
		tier: "LC",
	},
	ninjask: {
		tier: "PU",
		doublesTier: "DUU",
		randomBattleMoves: ["aerialace", "finalgambit", "swordsdance", "uturn", "xscissor"],
	},
	shedinja: {
		tier: "PU",
		doublesTier: "DUU",
		randomBattleMoves: ["shadowclaw", "shadowsneak", "willowisp", "xscissor"],
	},
	whismur: {
		tier: "LC",
	},
	loudred: {
		tier: "NFE",
	},
	exploud: {
		tier: "RU",
		doublesTier: "DUU",
		randomBattleMoves: ["boomburst", "fireblast", "focusblast", "surf"],
	},
	makuhita: {
		tier: "LC",
	},
	hariyama: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["bulkup", "bulletpunch", "closecombat", "knockoff", "poisonjab", "stoneedge"],
	},
	nosepass: {
		tier: "LC",
	},
	probopass: {
		tier: "PU",
		doublesTier: "DUU",
		randomBattleMoves: ["bodypress", "flashcannon", "stealthrock", "thunderwave", "voltswitch"],
	},
	skitty: {
		tier: "LC",
	},
	delcatty: {
		tier: "PU",
		doublesTier: "DUU",
		randomBattleMoves: ["doubleedge", "fakeout", "healbell", "suckerpunch", "thunderwave"],
	},
	sableye: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["foulplay", "knockoff", "recover", "taunt", "willowisp"],
	},
	mawile: {
		tier: "PU",
		doublesTier: "DUU",
		randomBattleMoves: ["ironhead", "playrough", "stealthrock", "suckerpunch", "swordsdance"],
	},
	aron: {
		tier: "LC",
	},
	lairon: {
		tier: "NFE",
	},
	aggron: {
		tier: "RU",
		doublesTier: "DUU",
		randomBattleMoves: ["earthquake", "headsmash", "heavyslam", "rockpolish", "superpower"],
	},
	meditite: {
		tier: "NFE",
	},
	medicham: {
		tier: "RU",
		doublesTier: "DUU",
		randomBattleMoves: ["bulletpunch", "fakeout", "highjumpkick", "icepunch", "recover", "zenheadbutt"],
	},
	electrike: {
		tier: "LC",
	},
	manectric: {
		tier: "PU",
		doublesTier: "DUU",
		randomBattleMoves: ["overheat", "switcheroo", "thunderbolt", "voltswitch"],
	},
	plusle: {
		tier: "PU",
		doublesTier: "DUU",
		randomBattleMoves: ["grassknot", "nastyplot", "nuzzle", "thunderbolt", "voltswitch"],
	},
	minun: {
		tier: "PU",
		doublesTier: "DUU",
		randomBattleMoves: ["grassknot", "nastyplot", "nuzzle", "switcheroo", "thunderbolt", "voltswitch"],
	},
	volbeat: {
		tier: "PU",
		doublesTier: "DUU",
		randomBattleMoves: ["encore", "roost", "thunderwave", "uturn"],
	},
	illumise: {
		tier: "PU",
		doublesTier: "DUU",
		randomBattleMoves: ["bugbuzz", "encore", "roost", "thunderwave", "wish"],
	},
	budew: {
		tier: "LC",
	},
	roselia: {
		tier: "NFE",
	},
	roserade: {
		tier: "UU",
		doublesTier: "DUU",
		randomBattleMoves: ["gigadrain", "leafstorm", "sleeppowder", "sludgebomb", "spikes", "toxicspikes"],
	},
	gulpin: {
		tier: "LC",
	},
	swalot: {
		tier: "PU",
		doublesTier: "DUU",
		randomBattleMoves: ["earthquake", "encore", "gunkshot", "icebeam", "painsplit", "toxic"],
	},
	carvanha: {
		tier: "LC",
	},
	sharpedo: {
		tier: "UU",
		doublesTier: "DUU",
		randomBattleMoves: ["aquajet", "crunch", "earthquake", "liquidation", "protect"],
	},
	wailmer: {
		tier: "LC",
	},
	wailord: {
		tier: "PU",
		doublesTier: "DUU",
		randomBattleMoves: ["clearsmog", "icebeam", "scald", "waterspout"],
	},
	numel: {
		tier: "LC",
	},
	camerupt: {
		tier: "PU",
		doublesTier: "DUU",
		randomBattleMoves: ["earthpower", "explosion", "fireblast", "lavaplume", "stealthrock"],
	},
	torkoal: {
		tier: "UU",
		doublesTier: "DOU",
		randomBattleMoves: ["earthquake", "lavaplume", "rapidspin", "solarbeam", "stealthrock"],
	},
	spoink: {
		tier: "LC",
	},
	grumpig: {
		tier: "PU",
		doublesTier: "DUU",
		randomBattleMoves: ["focusblast", "nastyplot", "psyshock", "shadowball"],
	},
	spinda: {
		tier: "PU",
		doublesTier: "DUU",
		randomBattleMoves: ["bodyslam", "encore", "fakeout", "rapidspin", "suckerpunch"],
	},
	trapinch: {
		tier: "LC",
	},
	vibrava: {
		tier: "NFE",
	},
	flygon: {
		tier: "UU",
		doublesTier: "DUU",
		randomBattleMoves: ["defog", "dragondance", "earthquake", "outrage", "superpower", "uturn", "roost"],
	},
	cacnea: {
		tier: "LC",
	},
	cacturne: {
		tier: "RU",
		doublesTier: "DUU",
		randomBattleMoves: ["drainpunch", "poisonjab", "seedbomb", "suckerpunch", "swordsdance"],
	},
	swablu: {
		tier: "LC",
	},
	altaria: {
		tier: "PU",
		doublesTier: "DUU",
		randomBattleMoves: ["dracometeor", "fireblast", "haze", "hurricane", "roost"],
	},
	zangoose: {
		tier: "NUBL",
		doublesTier: "DUU",
		randomBattleMoves: ["closecombat", "facade", "quickattack", "shadowclaw", "swordsdance"],
	},
	seviper: {
		tier: "PU",
		doublesTier: "DUU",
		randomBattleMoves: ["crunch", "earthquake", "flamethrower", "gigadrain", "glare", "sludgebomb", "switcheroo"],
	},
	lunatone: {
		tier: "PU",
		doublesTier: "DUU",
		randomBattleMoves: ["icebeam", "moonblast", "nastyplot", "psyshock", "stealthrock"],
	},
	solrock: {
		tier: "PU",
		doublesTier: "DUU",
		randomBattleMoves: ["earthquake", "explosion", "stealthrock", "stoneedge", "willowisp"],
	},
	barboach: {
		tier: "LC",
	},
	whiscash: {
		tier: "PU",
		doublesTier: "DUU",
		randomBattleMoves: ["dragondance", "earthquake", "stoneedge", "waterfall"],
	},
	corphish: {
		tier: "LC",
	},
	crawdaunt: {
		tier: "OU",
		doublesTier: "DUU",
		randomBattleMoves: ["aquajet", "crabhammer", "dragondance", "knockoff", "superpower"],
	},
	baltoy: {
		tier: "LC",
	},
	claydol: {
		tier: "RU",
		doublesTier: "DUU",
		randomBattleMoves: ["earthquake", "icebeam", "psychic", "rapidspin", "stealthrock"],
	},
	lileep: {
		tier: "LC",
	},
	cradily: {
		tier: "NU",
		doublesTier: "DOU",
		randomBattleMoves: ["gigadrain", "recover", "stealthrock", "stoneedge"],
	},
	anorith: {
		tier: "LC",
	},
	armaldo: {
		tier: "PU",
		doublesTier: "DUU",
		randomBattleMoves: ["aquajet", "knockoff", "rapidspin", "stealthrock", "stoneedge", "xscissor"],
	},
	feebas: {
		tier: "LC",
	},
	milotic: {
		tier: "UU",
		doublesTier: "DOU",
		randomBattleMoves: ["dragontail", "icebeam", "rest", "scald", "sleeptalk"],
	},
	castform: {
		tier: "PU",
		doublesTier: "DUU",
		randomBattleMoves: ["flamethrower", "icebeam", "scald", "thunderbolt"],
	},
	kecleon: {
		tier: "PU",
		doublesTier: "DUU",
		randomBattleMoves: ["drainpunch", "fakeout", "shadowsneak", "stealthrock", "thunderwave"],
	},
	shuppet: {
		tier: "LC",
	},
	banette: {
		tier: "PU",
		doublesTier: "DUU",
		randomBattleMoves: ["destinybond", "knockoff", "shadowclaw", "shadowsneak", "willowisp"],
	},
	duskull: {
		tier: "LC",
	},
	dusclops: {
		tier: "NFE",
	},
	dusknoir: {
		tier: "NU",
		doublesTier: "DUU",
		randomBattleMoves: ["earthquake", "icepunch", "painsplit", "shadowpunch", "shadowsneak", "willowisp"],
	},
	tropius: {
		tier: "PU",
		doublesTier: "DUU",
		randomBattleMoves: ["defog", "substitute", "leechseed", "airslash"],
	},
	chingling: {
		tier: "LC",
	},
	chimecho: {
		tier: "PUBL",
		doublesTier: "DUU",
		randomBattleMoves: ["healingwish", "lightscreen", "psychic", "recover", "reflect", "thunderwave"],
	},
	absol: {
		tier: "NUBL",
		doublesTier: "DUU",
		randomBattleMoves: ["knockoff", "playrough", "suckerpunch", "swordsdance"],
	},
	snorunt: {
		tier: "LC",
	},
	glalie: {
		tier: "PU",
		doublesTier: "DUU",
		randomBattleMoves: ["disable", "earthquake", "freezedry", "protect", "substitute"],
	},
	froslass: {
		tier: "RU",
		doublesTier: "DUU",
		randomBattleMoves: ["destinybond", "icebeam", "shadowball", "spikes", "taunt", "willowisp"],
	},
	spheal: {
		tier: "LC",
	},
	sealeo: {
		tier: "NFE",
	},
	walrein: {
		tier: "PU",
		doublesTier: "DUU",
		randomBattleMoves: ["icebeam", "rest", "sleeptalk", "surf"],
	},
	clamperl: {
		tier: "LC",
	},
	huntail: {
		tier: "PUBL",
		doublesTier: "DUU",
		randomBattleMoves: ["crunch", "icebeam", "shellsmash", "waterfall"],
	},
	gorebyss: {
		tier: "PUBL",
		doublesTier: "DUU",
		randomBattleMoves: ["hydropump", "icebeam", "psychic", "shellsmash"],
	},
	relicanth: {
		tier: "PU",
		doublesTier: "DUU",
		randomBattleMoves: ["doubleedge", "earthquake", "headsmash", "stealthrock", "waterfall", "yawn"],
	},
	luvdisc: {
		tier: "PU",
		doublesTier: "DUU",
		randomBattleMoves: ["charm", "icebeam", "scald", "sweetkiss"],
	},
	bagon: {
		tier: "LC",
	},
	shelgon: {
		tier: "NFE",
	},
	salamence: {
		tier: "UUBL",
		doublesTier: "DOU",
		randomBattleMoves: ["aerialace", "dragondance", "earthquake", "outrage", "roost", "stoneedge"],
	},
	beldum: {
		tier: "LC",
	},
	metang: {
		tier: "NFE",
	},
	metagross: {
		tier: "UU",
		doublesTier: "DUU",
		randomBattleMoves: ["agility", "bulletpunch", "earthquake", "explosion", "meteormash", "zenheadbutt"],
	},
	regirock: {
		tier: "NU",
		doublesTier: "DUU",
		randomBattleMoves: ["curse", "drainpunch", "earthquake", "rest", "stealthrock", "stoneedge"],
	},
	regice: {
		tier: "PU",
		doublesTier: "DUU",
		randomBattleMoves: ["focusblast", "icebeam", "rest", "rockpolish", "sleeptalk", "thunderbolt"],
	},
	registeel: {
		tier: "RU",
		doublesTier: "DUU",
		randomBattleMoves: ["curse", "ironhead", "rest", "sleeptalk"],
	},
	latias: {
		tier: "OU",
		doublesTier: "DUU",
		randomBattleMoves: ["calmmind", "dracometeor", "healingwish", "psychic", "roost", "surf"],
	},
	latios: {
		tier: "Uber",
		doublesTier: "DOU",
		randomBattleMoves: ["calmmind", "dracometeor", "psychic", "roost"],
	},
	kyogre: {
		tier: "Uber",
		doublesTier: "DUber",
		randomBattleMoves: ["calmmind", "icebeam", "originpulse", "thunder", "waterspout"],
	},
	groudon: {
		tier: "Uber",
		doublesTier: "DUber",
		randomBattleMoves: ["precipiceblades", "rockpolish", "stoneedge", "swordsdance"],
	},
	rayquaza: {
		tier: "Uber",
		doublesTier: "DUber",
		randomBattleMoves: ["dragonascent", "dragondance", "earthquake", "extremespeed", "outrage"],
	},
	jirachi: {
		tier: "OU",
		doublesTier: "DUU",
		randomBattleMoves: ["healingwish", "stealthrock", "thunderwave", "uturn", "zenheadbutt"],
	},
	deoxys: {
		tier: "Uber",
		doublesTier: "DOU",
		randomBattleMoves: ["superpower", "icebeam", "knockoff", "psychoboost", "stealthrock", "toxicspikes", "extremespeed"],
	},
	deoxysattack: {
		tier: "Uber",
		doublesTier: "DOU",
		randomBattleMoves: ["extremespeed", "icebeam", "knockoff", "psychoboost", "superpower"],
	},
	deoxysdefense: {
		tier: "Uber",
		doublesTier: "DOU",
		randomBattleMoves: ["knockoff", "nightshade", "recover", "stealthrock", "taunt", "teleport", "toxicspikes"],
	},
	deoxysspeed: {
		tier: "Uber",
		doublesTier: "DOU",
		randomBattleMoves: ["knockoff", "psychic", "stealthrock", "taunt", "toxicspikes"],
	},
	turtwig: {
		tier: "LC",
	},
	grotle: {
		tier: "NFE",
	},
	torterra: {
		tier: "RU",
		doublesTier: "DUU",
		randomBattleMoves: ["earthquake", "rockpolish", "stealthrock", "stoneedge", "synthesis", "woodhammer"],
	},
	chimchar: {
		tier: "LC",
	},
	monferno: {
		tier: "NFE",
	},
	infernape: {
		tier: "OU",
		doublesTier: "DOU",
		randomBattleMoves: ["closecombat", "flareblitz", "machpunch", "stealthrock", "stoneedge", "swordsdance", "uturn"],
	},
	piplup: {
		tier: "LC",
	},
	prinplup: {
		tier: "NFE",
	},
	empoleon: {
		tier: "UU",
		doublesTier: "DUU",
		randomBattleMoves: ["agility", "defog", "grassknot", "icebeam", "scald", "stealthrock"],
	},
	starly: {
		tier: "LC",
	},
	staravia: {
		tier: "NFE",
	},
	staraptor: {
		tier: "OU",
		doublesTier: "DUU",
		randomBattleMoves: ["bravebird", "closecombat", "doubleedge", "quickattack", "uturn"],
	},
	bidoof: {
		tier: "LC",
	},
	bibarel: {
		tier: "NUBL",
		doublesTier: "DUU",
		randomBattleMoves: ["aquajet", "aquatail", "curse", "quickattack", "rest"],
	},
	kricketot: {
		tier: "LC",
	},
	kricketune: {
		tier: "PU",
		doublesTier: "DUU",
		randomBattleMoves: ["brickbreak", "bugbite", "nightslash", "stickyweb"],
	},
	shinx: {
		tier: "LC",
	},
	luxio: {
		tier: "NFE",
	},
	luxray: {
		tier: "PU",
		doublesTier: "DUU",
		randomBattleMoves: ["crunch", "facade", "voltswitch", "wildcharge"],
	},
	cranidos: {
		tier: "LC",
	},
	rampardos: {
		tier: "PU",
		doublesTier: "DUU",
		randomBattleMoves: ["crunch", "earthquake", "headsmash", "rockpolish", "zenheadbutt"],
	},
	shieldon: {
		tier: "LC",
	},
	bastiodon: {
		tier: "PU",
		doublesTier: "DUU",
		randomBattleMoves: ["metalburst", "roar", "rockblast", "stealthrock"],
	},
	burmy: {
		tier: "LC",
	},
	wormadam: {
		tier: "PU",
		doublesTier: "DUU",
		randomBattleMoves: ["bugbuzz", "leafstorm", "psychic", "quiverdance", "shadowball"],
	},
	wormadamsandy: {
		tier: "PU",
		doublesTier: "DUU",
		randomBattleMoves: ["bugbuzz", "earthquake", "rockblast", "stealthrock"],
	},
	wormadamtrash: {
		tier: "PU",
		doublesTier: "DUU",
		randomBattleMoves: ["bugbuzz", "flashcannon", "gigadrain", "quiverdance", "stealthrock"],
	},
	mothim: {
		tier: "PU",
		doublesTier: "DUU",
		randomBattleMoves: ["airslash", "bugbuzz", "energyball", "quiverdance", "roost"],
	},
	combee: {
		tier: "LC",
	},
	vespiquen: {
		tier: "PU",
		doublesTier: "DUU",
		randomBattleMoves: ["attackorder", "roost", "substitute", "toxic", "uturn"],
	},
	pachirisu: {
		tier: "PU",
		doublesTier: "DUU",
		randomBattleMoves: ["nuzzle", "superfang", "thunderbolt", "uturn"],
	},
	buizel: {
		tier: "LC",
	},
	floatzel: {
		tier: "PU",
		doublesTier: "DUU",
		randomBattleMoves: ["aquajet", "brickbreak", "bulkup", "substitute", "taunt", "waterfall"],
	},
	cherubi: {
		tier: "LC",
	},
	cherrim: {
		tier: "PU",
		doublesTier: "DUU",
		randomBattleMoves: ["dazzlinggleam", "gigadrain", "healingwish", "petaldance"],
	},
	shellos: {
		tier: "LC",
	},
	gastrodon: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["earthquake", "icebeam", "recover", "scald"],
	},
	drifloon: {
		tier: "LC",
	},
	drifblim: {
		tier: "NU",
		doublesTier: "DUU",
		randomBattleMoves: ["calmmind", "shadowball", "strengthsap", "thunderbolt"],
	},
	buneary: {
		tier: "LC",
	},
	lopunny: {
		tier: "PU",
		doublesTier: "DUU",
		randomBattleMoves: ["facade", "healingwish", "highjumpkick", "switcheroo"],
	},
	glameow: {
		tier: "LC",
	},
	purugly: {
		tier: "PU",
		doublesTier: "DUU",
		randomBattleMoves: ["bodyslam", "fakeout", "quickattack", "suckerpunch", "uturn"],
	},
	stunky: {
		tier: "LC",
	},
	skuntank: {
		tier: "NU",
		doublesTier: "DUU",
		randomBattleMoves: ["crunch", "defog", "fireblast", "poisonjab", "suckerpunch", "taunt"],
	},
	bronzor: {
		tier: "LC",
	},
	bronzong: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["earthquake", "gyroball", "psychic", "stealthrock"],
	},
	chatot: {
		tier: "PU",
		doublesTier: "DUU",
		randomBattleMoves: ["boomburst", "chatter", "nastyplot", "substitute", "uturn"],
	},
	spiritomb: {
		tier: "RU",
		doublesTier: "DUU",
		randomBattleMoves: ["calmmind", "darkpulse", "psychic", "rest", "sleeptalk", "willowisp"],
	},
	gible: {
		tier: "LC",
	},
	gabite: {
		tier: "NFE",
	},
	garchomp: {
		tier: "OU",
		doublesTier: "DOU",
		randomBattleMoves: ["earthquake", "fireblast", "outrage", "stealthrock", "stoneedge", "swordsdance"],
	},
	riolu: {
		tier: "LC",
	},
	lucario: {
		tier: "OU",
		doublesTier: "DUU",
		randomBattleMoves: ["closecombat", "extremespeed", "meteormash", "stoneedge", "swordsdance"],
	},
	hippopotas: {
		tier: "LC",
	},
	hippowdon: {
		tier: "UU",
		doublesTier: "DUU",
		randomBattleMoves: ["earthquake", "slackoff", "stealthrock", "stoneedge", "whirlwind"],
	},
	skorupi: {
		tier: "LC",
	},
	drapion: {
		tier: "UU",
		doublesTier: "DUU",
		randomBattleMoves: ["earthquake", "knockoff", "poisonjab", "swordsdance", "taunt", "toxicspikes", "whirlwind"],
	},
	croagunk: {
		tier: "LC",
	},
	toxicroak: {
		tier: "NU",
		doublesTier: "DUU",
		randomBattleMoves: ["drainpunch", "poisonjab", "substitute", "suckerpunch", "swordsdance"],
	},
	carnivine: {
		tier: "PU",
		doublesTier: "DUU",
		randomBattleMoves: ["crunch", "powerwhip", "sleeppowder", "substitute", "swordsdance"],
	},
	finneon: {
		tier: "LC",
	},
	lumineon: {
		tier: "PU",
		doublesTier: "DUU",
		randomBattleMoves: ["defog", "icebeam", "scald", "uturn"],
	},
	snover: {
		tier: "LC",
	},
	abomasnow: {
		tier: "PUBL",
		doublesTier: "DOU",
		randomBattleMoves: ["auroraveil", "blizzard", "earthquake", "iceshard", "woodhammer"],
	},
	rotom: {
		tier: "RU",
		doublesTier: "DUU",
		randomBattleMoves: ["nastyplot", "shadowball", "thunderbolt", "trick", "voltswitch", "willowisp"],
	},
	rotomheat: {
		tier: "UU",
		doublesTier: "DUU",
		randomBattleMoves: ["nastyplot", "overheat", "thunderbolt", "trick", "voltswitch", "willowisp"],
	},
	rotomwash: {
		tier: "OU",
		doublesTier: "DOU",
		randomBattleMoves: ["hydropump", "nastyplot", "thunderbolt", "trick", "voltswitch", "willowisp"],
	},
	rotomfrost: {
		tier: "PU",
		doublesTier: "DUU",
		randomBattleMoves: ["blizzard", "nastyplot", "thunderbolt", "trick", "voltswitch", "willowisp"],
	},
	rotomfan: {
		tier: "PU",
		doublesTier: "DUU",
		randomBattleMoves: ["airslash", "nastyplot", "thunderbolt", "trick", "voltswitch", "willowisp"],
	},
	rotommow: {
		tier: "UU",
		doublesTier: "DUU",
		randomBattleMoves: ["leafstorm", "nastyplot", "thunderbolt", "trick", "voltswitch", "willowisp"],
	},
	uxie: {
		tier: "UU",
		doublesTier: "DUU",
		randomBattleMoves: ["psychic", "stealthrock", "thunderwave", "uturn", "yawn"],
	},
	mesprit: {
		tier: "NU",
		doublesTier: "DUU",
		randomBattleMoves: ["energyball", "healingwish", "icebeam", "nastyplot", "psychic", "thunderbolt", "uturn"],
	},
	azelf: {
		tier: "OU",
		doublesTier: "DUU",
		randomBattleMoves: ["dazzlinggleam", "fireblast", "nastyplot", "psychic", "stealthrock", "taunt", "thunderbolt", "uturn"],
	},
	dialga: {
		tier: "Uber",
		doublesTier: "DUber",
		randomBattleMoves: ["dracometeor", "fireblast", "flashcannon", "stealthrock", "thunderbolt"],
	},
	palkia: {
		tier: "Uber",
		doublesTier: "DUber",
		randomBattleMoves: ["dracometeor", "fireblast", "hydropump", "spacialrend", "thunderwave"],
	},
	heatran: {
		tier: "OU",
		doublesTier: "DOU",
		randomBattleMoves: ["earthpower", "flashcannon", "lavaplume", "roar", "stealthrock", "taunt"],
	},
	regigigas: {
		tier: "PU",
		doublesTier: "DUU",
		randomBattleMoves: ["knockoff", "rest", "sleeptalk", "strength"],
	},
	giratina: {
		tier: "Uber",
		doublesTier: "DUber",
		randomBattleMoves: ["aurasphere", "calmmind", "dragonpulse", "rest", "shadowball", "sleeptalk"],
	},
	giratinaorigin: {
		tier: "Uber",
		doublesTier: "DUber",
		randomBattleMoves: ["aurasphere", "defog", "dracometeor", "shadowball", "willowisp"],
	},
	cresselia: {
		tier: "RUBL",
		doublesTier: "DOU",
		randomBattleMoves: ["calmmind", "moonblast", "moonlight", "psychic", "thunderwave"],
	},
	phione: {
		tier: "PU",
		doublesTier: "DUU",
		randomBattleMoves: ["icebeam", "raindance", "rest", "scald"],
	},
	manaphy: {
		tier: "Uber",
		doublesTier: "DUU",
		randomBattleMoves: ["energyball", "icebeam", "substitute", "surf", "tailglow"],
	},
	darkrai: {
		tier: "Uber",
		doublesTier: "DOU",
		randomBattleMoves: ["darkpulse", "focusblast", "hypnosis", "nastyplot"],
	},
	shaymin: {
		tier: "UU",
		doublesTier: "DOU",
		randomBattleMoves: ["healingwish", "leechseed", "psychic", "rest", "seedflare", "substitute"],
	},
	shayminsky: {
		tier: "Uber",
		doublesTier: "DOU",
		randomBattleMoves: ["airslash", "leechseed", "seedflare", "substitute", "synthesis"],
	},
	arceus: {
		tier: "Uber",
		doublesTier: "DUber",
		randomBattleMoves: ["earthquake", "extremespeed", "recover", "shadowclaw", "swordsdance"],
	},
	arceusbug: {
		randomBattleMoves: ["earthquake", "extremespeed", "recover", "stoneedge", "swordsdance", "xscissor"],
	},
	arceusdark: {
		randomBattleMoves: ["calmmind", "fireblast", "judgment", "recover", "sludgebomb"],
	},
	arceusdragon: {
		randomBattleMoves: ["calmmind", "fireblast", "judgment", "recover", "sludgebomb"],
	},
	arceuselectric: {
		randomBattleMoves: ["calmmind", "earthpower", "icebeam", "judgment", "recover"],
	},
	arceusfairy: {
		randomBattleMoves: ["calmmind", "earthpower", "fireblast", "judgment", "recover"],
	},
	arceusfighting: {
		randomBattleMoves: ["calmmind", "icebeam", "judgment", "recover", "shadowball"],
	},
	arceusfire: {
		randomBattleMoves: ["calmmind", "judgment", "recover", "surf", "thunderbolt"],
	},
	arceusflying: {
		randomBattleMoves: ["calmmind", "earthpower", "fireblast", "icebeam", "judgment", "recover"],
	},
	arceusghost: {
		randomBattleMoves: ["judgment", "calmmind", "focusblast", "recover"],
	},
	arceusgrass: {
		randomBattleMoves: ["calmmind", "fireblast", "icebeam", "judgment", "recover"],
	},
	arceusground: {
		randomBattleMoves: ["earthquake", "extremespeed", "recover", "stoneedge", "swordsdance"],
	},
	arceusice: {
		randomBattleMoves: ["calmmind", "fireblast", "judgment", "recover", "thunderbolt"],
	},
	arceuspoison: {
		randomBattleMoves: ["calmmind", "defog", "earthpower", "recover", "sludgebomb"],
	},
	arceuspsychic: {
		randomBattleMoves: ["calmmind", "fireblast", "icebeam", "judgment", "recover"],
	},
	arceusrock: {
		randomBattleMoves: ["earthquake", "extremespeed", "recover", "stoneedge", "swordsdance"],
	},
	arceussteel: {
		randomBattleMoves: ["defog", "judgment", "recover", "roar", "stealthrock", "earthpower", "willowisp"],
	},
	arceuswater: {
		randomBattleMoves: ["defog", "icebeam", "judgment", "recover", "roar"],
	},
	// Because it's marked as Unobtainable in the main file for some reason
	eternatuseternamax: {
		inherit: true,
		isNonstandard: "Past",
	},
};
